import React, { Component } from 'react'
import { Link, withRouter } from "react-router-dom";

class Backbtn extends Component {

    backLink() {
        const link = this.props.location.pathname
        if(link === "/pointdetail" ||
            link === "/productbrand" ||
            link === "/promotion" ||
            link === '/downloadbrand' ||
            link === '/partsbrand'
        )
            return "/profile"
        else if (link === "/producttype") return "/productbrand"
        else if (link === "/productdetail") return "/producttype"+this.props.backSearch
        else if (link === "/promotiondetail") return "/promotion"
        else if (link === "/downloaddetail") return "/downloadbrand"
        else if (link === "/partsdetail") return "/partsbrand"
    }

    render() { 
        return ( 
            <div className="btn-back">
                <Link to={this.backLink()}><img src={require("../../static/images/00_global/back.png")} alt="ย้อนกลับ"/></Link>
            </div> );
    }
}
 
export default withRouter(Backbtn);